import "./App.css";
import React, { useEffect } from "react";
import logo from "./logo.svg";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Layout/Header";
import FristConten from "./Pages/FristConten";
import Footer from "./Layout/Footer";
import SingleBlog from "./Pages/SingleBlog";
import AllBlogs from "./Pages/AllBlogs";
import ContactUs from "./Pages/ContactUs";
import NotFound from "./Pages/NotFound"; // Create this component
import Privacy_Policy from "./Pages/Privacy_Policy";
import Terms_Conditions from "./Pages/Terms_Conditions";
import Shipping_delivery from "./Pages/Shipping_delivery";
import Cancellation_policy from "./Pages/Cancellation_policy";



function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<FristConten />} />
        <Route path="/blog/details" element={<SingleBlog />} />
        <Route path="/blogs" element={<AllBlogs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-and-conditions" element={<Terms_Conditions />} />
        <Route path="/shipping-delivery-policy" element={<Shipping_delivery />} />
        <Route path="/cancellation-policy" element={<Cancellation_policy />} />
        {/* Catch-all 404 route */}
        <Route path="/refer-restaurant" element={<FristConten />} />
        <Route path="/enroll-restaurant" element={<FristConten />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
